





































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import "dropzone/dist/dropzone.css";
import Dropzone from "dropzone";
import { AwsService as awsApi } from "@/common/api/services/AwsService";
import {
  FileManagementService as fileApi,
  FileAddFileUploadResponseApiRespoonse,
} from "@/common/api";
import _isEmpty from "lodash/isEmpty";

Dropzone.autoDiscover = false;

@Component({
  name: "uploadFile",
  components: {},
})
export default class uploadFile extends Vue {
  @Prop({
    default: () => {
      return {
        uploadMultiple: false,
      };
    },
  })
  options;

  @Prop({
    default: () => [],
  })
  files;

  @Prop({ default: true })
  showDefault: boolean;

  @Prop({ default: false })
  preventDuplicateName;

  @Prop({ default: false })
  preventMultiSelect;

  selfFiles = [];

  dropzone;
  // files = [];
  fileErrors = [];
  @Watch("files")
  watchFileInput() {
    this.selfFiles = [...this.files.filter((item) => !_isEmpty(item))];
  }
  mounted() {
    this.selfFiles = [...this.files.filter((item) => !_isEmpty(item))];
    let localOptions = {
      // The URL will be changed for each new file being processing
      url: "/",
      // Since we're going to do a `PUT` upload to S3 directly
      method: "PUT",
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending(file, xhr) {
        let _send = xhr.send;
        xhr.send = () => {
          _send.call(xhr, file);
        };
      },
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: "",
      // Customize the wording
      dictDefaultMessage: document.querySelector("#dropzone-message").innerHTML,
      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,
      // Here we request a signed upload URL when a file being accepted
      accept: async (file, done) => {
        if (
          this.preventDuplicateName &&
          this.files
            .map((item) => item.nameOriginal ?? item.name)
            .includes(file.name)
        ) {
          this.$emit(
            "pushError",
            "同じファイルが登録されています。アップロード済みのファイルを確認するかファイル名を変更していください"
          );
          this.dropzone.removeFile(file);
          return;
        }
        const extension = file.name.split(".").pop();
        const result = await awsApi.awsUploadFilePresign({
          filePath: file.upload.uuid + "." + extension,
        });
        file.uploadURL = result.data.presign.url;
        (file.filePath = file.upload.uuid + "." + extension), done();
        setTimeout(() => this.dropzone.processFile(file));
      },
    };
    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, {
      ...localOptions,
      ...this.options,
    });

    if (this.preventDuplicateName) {
      this.dropzone.hiddenFileInput.removeAttribute("multiple");
    }

    // Set signed upload URL for each file
    this.dropzone.on("processing", (file) => {
      this.dropzone.options.url = file.uploadURL;
    });
    this.dropzone.on("success", (file) => this.addFile(file));
    this.dropzone.on("uploadprogress", (file) => this.addFile(file));
    this.dropzone.on("error", (file, message) => this.addFile(file, message));
  }

  open() {
    this.dropzone.hiddenFileInput.click();
  }

  async addFile(file, message = "") {
    if (file.status === "error") {
      this.handelError(file, message);
      return;
    }
    if (file.status === "success") {
      // call api add file
      let result: FileAddFileUploadResponseApiRespoonse;
      try {
        result = await fileApi.filesAddFileUpload({
          name: file.filePath,
          nameOriginal: file.name,
          sipPath: "",
          category: "File",
          mimeType: file.type,
          size: file.size,
          md5: "md5",
        });
      } catch (error) {
        result = error.body;
      }
      if (result.status === "error") {
        file.status = "error";
        this.handelError(file, result.message);
      } else {
        this.selfFiles.push(file);
        this.$emit("changed", [result.data.file]);
      }
    }
    this.$emit("updateStatus", file.status);
    this.reRender();
  }

  public reRender() {
    this.selfFiles.unshift({ w: 1 });
    this.selfFiles.shift();
  }

  public removeFile(file, index) {
    // this.dropzone.files;
    const fileUpload = this.dropzone.files.find(
      (item) => item.filePath === file.name
    );
    if (fileUpload) {
      // instance of file
      this.dropzone.removeFile(fileUpload);
    }
    this.selfFiles.splice(index, 1);
    this.$emit(
      "changed",
      this.selfFiles,
      true // flag = true when remove file
    );
  }

  public removeAllFile() {
    if (this.dropzone.files.length > 0) {
      for (const file of this.dropzone.files) {
        this.dropzone.removeFile(file);
      }
    }
  }

  handelError(file, message = "") {
    if (
      this.options.acceptedFiles &&
      !this.options.acceptedFiles.includes(
        file.type.replace("application/", "")
      )
    ) {
      message = `アップロード可能な画像形式は${this.options.acceptedFiles
        .replace(".", "")
        .replace(",", "・")}になります`;
    }

    if (
      this.options.maxFilesize &&
      file.size > this.options.maxFilesize * 1024 * 1024
    ) {
      message = `アップロード可能なサイズは ${this.options.maxFilesize}MB以下 になります`;
    }

    file.errorMessage = message;
    this.$emit("pushError", message);
    this.dropzone.removeFile(file);
  }
}
